import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const EditServiceMasterPage = withSuspense(lazy(() => import('./edit-services-master-page')));
export default EditServiceMasterPage;
